module.exports = __webpack_public_path__ + "img/BGIMGHOME3.0e66cc74.png";